import {
  ACTION_EDIT_TRANSACTION,
  ACTION_EDIT_TRANSACTION_SUCCESS,
  ACTION_EDIT_TRANSACTION_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

interface EditTransactionParams {
  transactionIds: string[];
  syncToGlStatus: string;
}

export function editTransaction(params: EditTransactionParams) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: 'synced-transactions',
        method: 'put',
        data: JSON.stringify({
          transactionIds: params.transactionIds,
          syncToGlStatus: params.syncToGlStatus,
        }),
        success: (response: any) => {
          enqueueSnackbarHandler(
            dispatch,
            { editTransactionSuccess: true },
            'success',
          );
          dispatch(requestSuccess(response));
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

function requestStarted() {
  return {
    type: ACTION_EDIT_TRANSACTION,
    payload: null,
  };
}

function requestSuccess(response: any) {
  return {
    type: ACTION_EDIT_TRANSACTION_SUCCESS,
    payload: response,
  };
}

function requestFailed(error: any) {
  return {
    type: ACTION_EDIT_TRANSACTION_FAILURE,
    payload: error,
  };
}
